import { AbstractWebStorageCacheManager } from "../AbstractWebStorageCacheManager";
import { ScaledMapData } from "./type";
import { isScaledMapData } from "./typeGuard";

/**
 * ScaledMapData専用のセッションキャッシュマネージャー
 * GeoJSONはJSON互換であるため、シリアライズ/デシリアライズは直接JSON処理を利用する
 */
export class ScaledMapDataCacheManager extends AbstractWebStorageCacheManager<ScaledMapData> {
  /**
   * @param floorPath_language キャッシュキーとして使用するフロアのパス（例: /main-3.geojson）
   * @param storageType 'session' または 'local' を指定
   */
  constructor(floorPath_language: string, storageType: "session" | "local" = "session") {
    // キーはフロアパス+言語と処理内容を組み合わせる (例: "scaledMapData:/main-3.geojson_ja")
    const key = `scaledMapData:${floorPath_language}`;
    super(key, storageType);
  }

  /**
   * GeoJSON構造はJSON互換なので、そのままJSONオブジェクトとして返します。
   */
  public serialize(data: ScaledMapData): object {
    // data (ScaledMapData) は、すべて JSON.stringify() で処理可能なプロパティを持つため、そのまま返す
    return data as object;
  }

  /**
   * JSONから復元します。型ガードチェックが必要です。
   */
  public deserialize(jsonObject: unknown): ScaledMapData | null {
    // 型ガード: 復元されたオブジェクトが ScaledMapData の構造を持つかチェック
    if (!isScaledMapData(jsonObject)) {
      console.error("Cache data structure mismatch for ScaledMapData.");
      return null;
    }
    return jsonObject;
  }
}
